"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const entities_1 = require("@umahealth/entities");
/**
 *
 * @param firestore
 * @param uid
 * @returns get medicalRecord from Specialists
 */
async function getSpecialistMedicalRecords(firestore, uid) {
    let pendingAppointments;
    try {
        const path = (0, entities_1.getMedicalRecordsPath)(uid, false);
        const specialistAppointments = (0, firestore_1.query)((0, firestore_1.collection)(firestore, path), (0, firestore_1.where)("att_category", "==", "MI_ESPECIALISTA"));
        pendingAppointments = await (0, firestore_1.getDocs)(specialistAppointments);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (pendingAppointments.empty) {
        return [];
    }
    return pendingAppointments.docs.map((document) => document.data());
}
exports.default = getSpecialistMedicalRecords;
